import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: auto 0;\n  min-width: ", ";\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { NO_VALUE } from '@scp/ui-shared/core';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { PillIndicator } from './PillIndicator';
var StatusPillIndicator = styled(PillIndicator).attrs({
  type: 'small'
})(_templateObject(), baselineToRem(26));

var statusColor = function statusColor(success) {
  if (success === null || success === undefined) {
    return 'light-grey';
  }

  return success ? 'light-green' : 'light-red';
};

export function Status(_a) {
  var success = _a.success,
      children = _a.children,
      dataE2e = _a.dataE2e,
      otherProps = __rest(_a, ["success", "children", "dataE2e"]);

  return React.createElement(StatusPillIndicator, Object.assign({
    color: statusColor(success),
    "data-e2e": getE2eLabel(children, '-status', dataE2e)
  }, otherProps), children || NO_VALUE);
}